var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',_vm._l((_vm.knowledgeUnitOptions),function(option,index){return _c('v-col',{key:`option-${option.id}`,attrs:{"cols":_vm.getColumn(index)}},[_c('OptionNode',{attrs:{"value":option,"disableInteraction":true,"selected":option.isAnswer ? option : {}},on:{"media":_vm.mediaEmit}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }